module.exports = __webpack_public_path__ + "img/budget-1.deeff5b6.jpg";